<template>
  <v-container>
    <div class="d-flex flex-wrap row--dense">
      <div class="col col-12 col-md-4">
        <v-text-field
          v-model="step.name"
          :rules="rules.name"
          counter="255"
          maxlength="255"
          clearable
          dense
          outlined
          :label="$t('commons.name')"
        />
      </div>
      <div class="col col-12 col-md-4">
        <DatetimePicker
          v-model="step.start_date"
          :max="getMinDatetime(maxDatetime, step.deadline)"
          :min="minDatetime"
          :textFieldProps="{
            dense: true,
            label: $t('commons.date.start_date'),
            rules: rules.start_date
          }"
        />
      </div>
      <div class="col col-12 col-md-4">
        <DatetimePicker
          v-model="step.deadline"
          :disabled="!step.start_date"
          :max="maxDatetime"
          :min="step.start_date"
          :textFieldProps="{
            dense: true,
            label: $t('commons.date.end_date'),
            rules: rules.deadline
          }"
        />
      </div>
    </div>
    <div class="d-flex justify-end mt-6 mb-4">
      <avs-createButton
        small
        @click.stop="addTask()"
        :spantext="$t('actions.add', { entity: $tc('commons.task', 1).toLowerCase() })"
        :name="$t('actions.new_female', { entity: $tc('commons.task', 1).toLowerCase() })"
      >
      </avs-createButton>
    </div>
    <div class="d-flex row--dense">
      <v-list class="ml-2">
        <v-list-item
          v-for="(task, taskIndex) in step.tasks.filter(s => !s.deleted)"
          :key="taskIndex"
        >
          <v-list-item-content>
            <div class="d-flex flex-wrap row--dense">
              <!-- <v-col
                class="col-12 pb-0 mb-0"
                v-if="pcq_dsi"
              >
                <v-checkbox v-model="task.create_pcq_dsi">
                  <template v-slot:label>
                    <div>{{ $t("categories.pcqdsi.is_pcq_dsi") }}</div>
                  </template>
                </v-checkbox>
              </v-col> -->
              <div class="col-6 col-lg-3">
                <v-text-field
                  v-model="task.name"
                  :rules="rules.task.name"
                  counter="255"
                  maxlength="255"
                  clearable
                  dense
                  outlined
                  :label="$t('categories.project.task')"
                />
              </div>
              <div class="col-6 col-lg-2">
                <v-select
                  v-model="task.status"
                  :rules="rules.task.status"
                  :items="STATUS_ITEMS"
                  dense
                  outlined
                  :label="$t('commons.status.name')"
                ></v-select>
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="task.start_date"
                  :disabled="!step.start_date || !step.deadline"
                  :max="getMinDatetime(step.deadline, task.deadline)"
                  :min="step.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.start_date'),
                    rules: rules.task.start_date
                  }"
                />
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="task.deadline"
                  :disabled="!task.start_date"
                  :max="step.deadline"
                  :min="task.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.end_date'),
                    rules: rules.task.deadline
                  }"
                />
              </div>
              <div class="col-1 col-lg-1">
                <avs-deleteButton
                  @click="openDeleteDialog(taskIndex)"
                  :spantext="
                    $t('actions.delete', {
                      entity: $tc('commons.task', 1).toLowerCase()
                    })
                  "
                />
              </div>
              <div class="col-6 col-lg-6 pl-2">
                <!-- <v-checkbox v-model="task.as_detail">
                  <template v-slot:label>
                    <div>{{ $t("commons.show_task_detail") }}</div>
                  </template>
                </v-checkbox> -->
                <v-switch
                  v-model="task.as_detail"
                  :label="$t('commons.show_task_detail')"
                  inset
                  color="success"
                ></v-switch>
              </div>
              <template v-if="task.as_detail">
                <div class="col-12 col-lg-12">
                  <label>{{ $t("commons.description") }}</label>
                  <ckeditor
                    :editor="editor"
                    tag-name="textarea"
                    rows="3"
                    v-model="task.description"
                    :config="editorConfig"
                    class="content-element"
                  ></ckeditor>
                </div>
                <div class="col-6 col-lg-6 mt-2">
                  <v-select
                    v-model="task.user"
                    :items="users"
                    dense
                    outlined
                    item-text="email"
                    item-value="id"
                    :label="$t('commons.monitoring_intended_for')"
                  />
                </div>
                <div class="col-6 col-lg-6 mt-1">
                  <v-row class="d-flex align-center mt-2">
                    <!-- Bouton d'upload -->
                    <v-btn
                      outlined
                      color="primary"
                      dense
                      @click="triggerFileUpload(taskIndex)"
                      class="ml-3"
                    >
                      <v-icon left>mdi-upload</v-icon>
                      {{ $t("commons.attachments") }}
                    </v-btn>

                    <!-- Affichage des fichiers chargés -->
                    <div
                      v-for="(attachment, index) in task.attachments"
                      :key="index"
                      class="d-flex align-center mr-4"
                    >
                      <!-- Si le fichier a un lien existant -->
                      <template v-if="attachment.file_url">
                        <a
                          :href="attachment.file_url"
                          target="_blank"
                          class="d-flex align-center"
                        >
                          <v-icon
                            medium
                            class="mr-2"
                            >mdi-file</v-icon
                          >
                          {{ attachment.name }}
                        </a>
                      </template>
                      <!-- Si c'est un nouveau fichier -->
                      <template v-else>
                        <div class="d-flex align-center">
                          <v-icon
                            medium
                            class="mr-2"
                            >mdi-file</v-icon
                          >
                          {{ attachment.name }}
                        </div>
                      </template>
                      <v-btn
                        icon
                        small
                        color="red"
                        @click="removeFile(index)"
                        class="ml-2"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>

                    <!-- Input invisible pour le téléchargement -->
                    <input
                      :ref="`fileInput${taskIndex}`"
                      type="file"
                      multiple
                      @change="handleFilesChange(task, $event)"
                      style="display: none"
                    />
                  </v-row>
                </div>
              </template>
            </div>
            <v-divider> </v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="closeDeleteDialog"
      @delete="deleteTask"
      resource="task"
    />
  </v-container>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { STATUS_ITEMS } from "@/utils/consts"
import CompanyService from "@/services/CompanyService"
import { mkProjectStepTask } from "@/utils/datamodels"
import { getMinDatetime } from "@/utils/datetime"
import { required } from "@/utils/validator"
import { TaskService } from "@/services"

export default {
  name: "ProjectActivityTask",
  components: {
    DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue")
  },
  created() {
    this.fetchUser()
  },
  props: {
    maxDatetime: {
      type: Object,
      required: true
    },
    minDatetime: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    },
    rulesUpdate: {
      type: Object,
      default: () => {}
    },
    pcq_dsi: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    companyId() {
      return this.$store.getters["app/getCompany"].pk
    },
    rules() {
      return {
        name: [required],
        start_date: [required],
        deadline: [required],
        task: {
          name: [required],
          status: [required],
          start_date: [required],
          deadline: [required]
        },
        ...this.rulesUpdate
      }
    }
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      STATUS_ITEMS,
      currentTask: null,
      attachments: [],
      taskIndex: null,
      editor: ClassicEditor,
      users: [],
      editorConfig: {
        toolbar: ["heading", "|", "bold", "italic", "link", "|", "undo", "redo"]
      }
    }
  },
  methods: {
    getMinDatetime,
    hasBeenUpdated() {
      this.$emit("updated")
    },
    triggerFileUpload(idx) {
      // Récupère la référence au <input> caché
      let input = this.$refs[`fileInput${idx}`]
      // Si c'est un tableau (dans certains cas Vue retourne un array)
      if (Array.isArray(input)) {
        input = input[0]
      }
      // Ouvre la dialog de sélection de fichier
      input.click()
    },
    // handleFilesChange(task, event) {
    //   const files = Array.from(event.target.files)
    //   files.forEach(file => {
    //     task.attachments.push({
    //       name: file.name,
    //       file, // pour envoi ultérieur
    //       id: null,
    //       file_url: null
    //     })
    //   })
    //   event.target.value = ""
    //   this.$emit("input", this.step)
    // },
    handleFilesChange(task, event) {
      const files = event.target.files || event.files

      Array.from(files).forEach(file => {
        const reader = new FileReader()

        reader.onload = () => {
          // reader.result est une data URL « data:…;base64,… »
          task.attachments.push({
            name: file.name,
            type: file.type,
            file: reader.result, // base64 pour envoi
            blob: new Blob([file], { type: file.type }) // Blob si besoin
          })

          // Notifier le parent que task.attachments a changé
          this.$emit("input", this.step)
        }

        // Lance la lecture en base64
        reader.readAsDataURL(file)
      })

      // Réinitialise l’input pour pouvoir re‑uploader les mêmes fichiers si besoin
      event.target.value = ""
    },
    removeFile(task, idx) {
      task.attachments.splice(idx, 1)
      this.$emit("input", this.step)
    },
    handleInputOther() {
      this.$emit("input", this.task)
    },
    addTask() {
      let order = this.step.tasks.length + 1
      this.step.tasks.push(
        mkProjectStepTask(
          this.step.start_date,
          this.step.deadline,
          order,
          this.$tc("commons.task", 1).toUpperCase()
        )
      )
    },
    deleteTask() {
      let task = this.step.tasks[this.taskIndex]
      if (task.id) {
        TaskService.remove(this, task.id).then(response => {
          this.send(
            this.$t("messages.success.deleted", { entity: this.$tc("commons.task", 1) }),
            "success"
          )
        })
        this.hasBeenUpdated()
      } else {
        this.step.tasks.splice(this.taskIndex, 1)
        this.send(
          this.$t("messages.success.deleted", { entity: this.$tc("commons.task", 1) }),
          "success"
        )
      }
      this.closeDeleteDialog()
    },
    async fetchUser() {
      this.users = await CompanyService.getMembers(this.companyId)
      this.$nextTick(() => {
        // reclé du composant pour le forcer à remonter la valeur
        this.$forceUpdate()
      })
    },
    closeDeleteDialog() {
      this.deleteDialogIsOpen = false
    },
    openDeleteDialog(taskIndex) {
      this.deleteDialogIsOpen = true
      this.taskIndex = taskIndex
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
<style lang="scss">
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.ck.ck-editor__main > .ck-editor__editable {
  height: 130px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
